import { render } from "./Orcaincluir.vue?vue&type=template&id=01d054da"
import script from "./Orcaincluir.vue?vue&type=script&lang=js"
export * from "./Orcaincluir.vue?vue&type=script&lang=js"

import "./Orcaincluir.vue?vue&type=style&index=0&id=01d054da&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__